import { render } from "./Upload.vue?vue&type=template&id=5f4d80a4&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=5f4d80a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f4d80a4"

export default script